import type { InjectionKey, Ref, ShallowRef } from 'vue'
import type { Density } from 'vuetify/lib/composables/density.mjs'

export interface ItemKeys {
  itemTitle: string
  itemValue: string
  itemChildren: string
  itemError: string
  itemType: string
  itemLoading: string
}

export interface ItemIcons {
  collapse?: string
  expand?: string
  empty?: string
  load?: string
  root?: string
  rootOpened?: string
  rootError?: string
  error?: string
}

export interface TreeData {
  parents: ShallowRef<Map<unknown, unknown>>
  children: ShallowRef<Map<unknown, unknown[]>>

  keys: ItemKeys
  icons: ItemIcons

  fillChildren: (item: unknown) => void
}

export const UTreeDataSymbol: InjectionKey<Ref<TreeData | undefined>> = Symbol('utreedata')

export function hasChildren<Item>(items?: Array<Item>): boolean {
  return items !== undefined
}

export function getItemTitle<Item>(item: Item, keys: ItemKeys): string {
  return (item as any)[keys.itemTitle]
}

export function getItemValue<Key, Item>(item: Item, keys: ItemKeys): Key {
  return (item as any)[keys.itemValue]
}

export function getItemChildren<Item>(item: Item, keys: ItemKeys): Array<Item> {
  return (item as any)[keys.itemChildren]
}

export function getItemError<Item>(item: Item, keys: ItemKeys): boolean {
  return (item as any)[keys.itemError]
}

export function getItemLoading<Item>(item: Item, keys: ItemKeys): boolean {
  return (item as any)[keys.itemLoading]
}

export function transformItem<Key, Item>(item: Item, keys: ItemKeys): { title: string, value: Key, [rest: string]: any } {
  return { title: getItemTitle(item, keys) as string, value: getItemValue(item, keys), ...(item as any) }
}

// eslint-disable-next-line unused-imports/no-unused-vars
export function getStyle(level: number): string {
  return `cursor: default;`
}

export function getDensityClass(density: Density): string {
  switch (density) {
    case 'compact':
      return 'density-compact'
    case 'comfortable':
      return 'density-comfortable'
    case 'default': default:
      return 'density-default'
  }
}

export function getDensityIconSize(density: Density) {
  switch (density) {
    case 'compact':
    case 'comfortable':
      return 'small'
    case 'default': default:
      return undefined
  }
}
